import moment from 'moment';
import { i18n } from '@/boot/i18n';
import ExportationService from '@/services/exportation'; // eslint-disable-line import/no-cycle
import ErrorHandler from '@/tools/errorHandler';
import { formatDate, formatTime, getUnixDate } from '@/utils/date';

import * as types from './mutationTypes';

function getName(organizationName, resourceName, offset, locale) {
  let orgName = organizationName;
  const date = formatDate(getUnixDate(moment()), offset, locale).replaceAll('/', '-');
  const hour = formatTime(getUnixDate(moment()), offset).slice(0, 5).replace(':', '-');

  if (orgName) {
    orgName = `${orgName.replace(' ', '').toUpperCase()}-`;
  }
  return `${(orgName || '') + resourceName}-${date}_${hour}`;
}

export default {
  initNewState({ rootState, getters, commit }) {
    commit(
      types.SET_NAME,
      getName(
        rootState.organization.organization?.name,
        getters.resourceName,
        rootState.organization.organization?.primary_time_offset,
        rootState.organization.organization?.primary_language,
      ),
    );
  },
  clearNewState({ commit }) {
    commit(types.CLEAR_EXPORT_DATA);
  },
  initListState({ commit }) {
    commit(types.SET_EXPORTS, []);
  },
  clearListState({ commit }) {
    commit(types.CLEAR_EXPORTS);
    commit(types.CLEAR_RESOURCE);
    commit(types.CLEAR_CONTEXT);
  },
  setExportsSuccess({ commit }, exports) {
    commit(types.SET_EXPORTS, exports);
  },
  removeExportation({ commit }, uuid) {
    commit(types.REMOVE_EXPORTATION, uuid);
  },
  async create({ rootState, dispatch, state }, fields) {
    try {
      const data = {
        name: state.exportData.name,
        resource: state.resource.key,
        fields,
        filter:
          `filter.created_at.starts_at:${
            state.exportData.pagination['filter.created_at.starts_at']
          },filter.created_at.ends_at:${
            state.exportData.pagination['filter.created_at.ends_at']
          },filter.loop_uuid:${rootState.loop.loop?.uuid},filter.dealt_status:${rootState.dealt?.queryParams['filter.status.equal']}`,
        order: {
          sort: state.exportData.pagination?.sortBy,
          descending: state.exportData.pagination?.descending ? 1 : null,
        },
        segmentUUID: state.exportData.segment,
        conditions: state.exportData.conditions,
      };

      if (state.context === 'organization') {
        await ExportationService.create(rootState.organization.organization.uuid, data);
      } else {
        await ExportationService.createGeneral(data);
      }
      return true;
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
      return false;
    }
  },
  async getAll({ rootState, dispatch }, resource) {
    try {
      const response = await ExportationService
        .getAll(rootState.organization.organization.uuid, resource);
      if (response.data.data) {
        dispatch('setExportsSuccess', response.data.data.exports);
      }
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },

  getOne({ rootState, state }, downloadUUID) {
    if (state.context === 'organization') {
      return ExportationService.getOne(rootState.organization.organization.uuid, downloadUUID);
    }
    return ExportationService.getOneGeneral(downloadUUID);
  },

  async delete({ rootState, dispatch, state }, downloadUUID) {
    try {
      if (state.context === 'organization') {
        await ExportationService.delete(rootState.organization.organization.uuid, downloadUUID);
      } else {
        await ExportationService.deleteGeneral(downloadUUID);
      }

      dispatch('removeExportation', downloadUUID);
      dispatch('ui/showToastSuccess', i18n.t('general.download.delete_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },

  async cancel({ rootState, dispatch }, uuid) {
    try {
      await ExportationService.cancel(rootState.organization.organization.uuid, uuid);
      dispatch('removeExportation', uuid);
      dispatch('ui/showToastSuccess', i18n.t('general.download.cancel_success'), { root: true });
    } catch (error) {
      dispatch('ui/showToastError', ErrorHandler.getErrorMessage(error), { root: true });
    }
  },

  setResource({ commit }, resource) {
    commit(types.SET_RESOURCE, resource);
  },
  setExportData({ commit }, exportData) {
    commit(types.SET_EXPORT_DATA, exportData);
  },
  setName({ commit }, name) {
    commit(types.SET_NAME, name);
  },
  setContext({ commit }, context) {
    commit(types.SET_CONTEXT, context);
  },
  clearContext({ commit }) {
    commit(types.CLEAR_CONTEXT);
  },
  setLoading({ commit }, loading) {
    commit(types.SET_LOADING, loading);
  },
};
